import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { api } from "@/lib/api/client";
import { unwrap } from "@/lib/api/unwrap";

/**
 * Under the catalogue's key on purpose: every catalogue write and restore
 * invalidates `["catalogue"]`, so a recoloured thematic is redrawn at once.
 */
export const THEMATIC_PALETTES_KEY = ["catalogue", "thematic-palettes"] as const;

/**
 * Writes the custom thematic colours into the page: the server's CSS defines
 * the `--theme-custom*` variables under each custom thematic's `css_class`
 * token, which `thematicClasses()` puts on the element it colours. Mounted once
 * with the app's providers; renders nothing.
 */
export function ThematicPalettes() {
  const { data } = useQuery({
    queryKey: THEMATIC_PALETTES_KEY,
    queryFn: () => unwrap(api.GET("/api/v1/questionnaire/thematic-palettes/", {})),
    staleTime: 5 * 60 * 1000,
  });
  const css = data?.css ?? "";

  useEffect(() => {
    const style = document.createElement("style");
    style.dataset.thematicPalettes = "";
    style.textContent = css;
    document.head.appendChild(style);
    return () => style.remove();
  }, [css]);

  return null;
}
